import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import CookieIcon from '@mui/icons-material/Cookie';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import back arrow icon

const PageNotFound = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
    >
      <Typography variant="h1" fontSize="5rem">
        404 <CookieIcon fontSize="large" />
      </Typography>
      <Typography variant="h4">Oops! Page not found</Typography>
      <Typography variant="body1" sx={{ maxWidth: 600, marginBottom: 3 }}>
        It's looking like you may have taken a wrong turn. Don't worry... it happens to the best of us. Here's a little tip that might help you get back on track.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/"
        sx={{
          marginTop: 2,
          backgroundColor: "#3bb77e",
          color: "#fff",
          padding: "12px 24px",
          fontSize: "1.2rem",
          borderRadius: "8px",
          width: "auto",
          display: "flex",
          alignItems: "center",
          "&:hover": {
            backgroundColor: "#32a068",
          },
        }}
      >
        <ArrowBackIcon sx={{ marginRight: 1 }} /> Back to main
      </Button>
    </Box>
  );
};

export default PageNotFound;
